import {Flex, FlexProps} from "@styled-system/jsx";
import {ReactNode} from 'react';

type AccentCardProps = {
  children: ReactNode
} & FlexProps;

const AccentCard = ({children, ...rest}: AccentCardProps) => {
  return <Flex
    bgColor="blue.50"
    p={{base: 2, md: 4}}
    borderRadius="md"
    flex={1}
    width="full"
    justifyContent="center"
    alignItems="center"
    minH={{base: 10, md: 20}}
    {...rest}
  >
    {children}
  </Flex>
}

export default AccentCard;
